/** The CMS frames this page to preview an unsaved patch log (next-jarvis#683). */
export const PATCH_LOG_PREVIEW_PATH = '/patch-log-preview';

/**
 * True on the CMS preview page. It is framed by the CMS on the same site as
 * Jarvis, so it shares localStorage with whoever is signed in to Jarvis in
 * this browser: app-wide code must neither read nor write their session,
 * profile preferences or stored settings here. Fixed at load, because the page
 * is only ever opened directly, never navigated to.
 */
export const isPatchLogPreviewPage =
  typeof window !== 'undefined' && window.location.pathname.replace(/\/+$/, '') === PATCH_LOG_PREVIEW_PATH;
